var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinmappBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 24077",
    transform: "translate(21445.502 21469.5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.365,
    cy: 2.081,
    "data-name": "Ellipse 940",
    rx: 9.365,
    ry: 2.081,
    transform: "translate(-21425.221 -21395.588)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M-21416.07-21394.39c-10.165 0-29.433-30.294-29.433-46.327 0-15.896 13.177-28.783 29.433-28.783s29.432 12.887 29.432 28.783c0 15.159-18.181 46.327-29.432 46.327Z",
    "data-name": "Path 38714"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#fff",
    "data-name": "Ellipse 939",
    transform: "translate(-21427.303 -21455.941)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.446,
    cy: 11.446,
    r: 11.446,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11.446,
    cy: 11.446,
    r: 10.946
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinmappBlack);
export default __webpack_public_path__ + "static/media/Pinmapp-black.0d727bbfec12d1d194d5436f6c2f2161.svg";
export { ForwardRef as ReactComponent };